import styled from '@emotion/styled'
import { motion } from 'framer-motion'
import { useCallback, useEffect, useRef, useState } from 'react'
import { useUpdateEffect } from 'react-use'
import { useRecoilState, useRecoilValue } from 'recoil'

import toScreenLeft from '@/assets/images/toScreenLeft.png'
import { roomWindowScaleState, screenSharingState } from '@/store/room'
import { ipcInvoke, ipcOn } from '@/utils/electron'

export default function Index() {
  const [screenSharing, setScreenSharing] = useRecoilState(screenSharingState)
  const [roomWindowScale, setRoomWindowScale] = useRecoilState(roomWindowScaleState)
  const [leftSide, setLeftSide] = useState<boolean>(false)
  const scales = [
    {
      label: '还原',
      value: 'full'
    },
    {
      label: '1X',
      value: '1X'
    },
    {
      label: '2X',
      value: '2X'
    }
  ]
  const mainWinWidth = Number(localStorage.workAreaWidth)
  const mainWinHeight = Number(localStorage.workAreaHeight)
  useUpdateEffect(() => {
    switch (roomWindowScale) {
      case 'full':
        // 恢复主窗口位置和大小
        ipcInvoke(
          'win',
          { method: 'setBounds' },
          {
            width: mainWinWidth,
            height: mainWinHeight,
            x: 0,
            y: 0
          },
          false
        )
        ipcInvoke('win', { method: 'setResizable' }, true)
        ipcInvoke('win', { method: 'setAlwaysOnTop' }, false)
        break
      case '1X':
      case '2X':
        const scale = {
          '1X': 1,
          '2X': 2
        }[roomWindowScale]
        ipcInvoke(
          'win',
          { method: 'setBounds' },
          {
            width: 510 * scale,
            height: 350 * scale,
            x: mainWinWidth - 550 * scale,
            y: 40
          },
          false
        )
        ipcInvoke('win', { method: 'setResizable' }, true)
        ipcInvoke('win', { method: 'setAlwaysOnTop' }, true, 'main-menu')
        break
      // 右侧吸侧
      case 'leftSide':
        ipcInvoke(
          'win',
          { method: 'setBounds' },
          {
            width: 50,
            height: 200,
            x: mainWinWidth - 40,
            y: 50
          },
          false
        )
        ipcInvoke('win', { method: 'setResizable' }, false)
        break
      default:
        ipcInvoke(
          'win',
          { method: 'setBounds' },
          {
            width: mainWinWidth,
            height: mainWinHeight,
            x: 0,
            y: 0
          },
          false
        )
        ipcInvoke('win', { method: 'setResizable' }, true)
        ipcInvoke('win', { method: 'setAlwaysOnTop' }, false)
        break
    }
  }, [roomWindowScale])

  if (roomWindowScale === 'full') return null

  return (
    <>
      {roomWindowScale === 'leftSide' ? (
        <div className="absolute top-0 left-0 z-[9999] flex w-full h-full items-center justify-center bg-[#000000] ">
          <div className="cursor-pointer" onClick={() => setRoomWindowScale('1X')}>
            <img src={toScreenLeft} width="20px" height="20px" className="origin-center rotate-180" alt="" />
          </div>
        </div>
      ) : (
        <Container className="absolute bottom-0 z-[9999] flex w-full h-[40px] justify-between  items-center bg-[#000000]  select-none truncate">
          <div className="flex items-center justify-center text-white">
            {scales.map((item, index) => {
              return (
                <div
                  key={index}
                  className={`h-26 px-6 rounded-full ml-8 ${roomWindowScale === item.value ? 'bg-[#2266FF]' : 'bg-[#262626] '} cursor-pointer`}
                  onClick={() => {
                    setRoomWindowScale(item.value as any)
                  }}
                >
                  {item.label}
                </div>
              )
            })}
          </div>
          <div className="drag flex flex-1 h-full"></div>
          <div className="cursor-pointer mr-5" onClick={() => setRoomWindowScale('leftSide')}>
            <img src={toScreenLeft} width="20px" height="20px" alt="" />
          </div>
        </Container>
      )}
    </>
  )
}

const Container = styled(motion.div)`
  .drag {
    -webkit-app-region: drag;
  }
`
